import FactureAvoirRecapController from './facture.avoir.recap.controller';

export default {
    bindings: {
        modalInstance: '=',
        recap: '='
    },
    template: require('./facture.avoir.recap.html'),
    controller: FactureAvoirRecapController
};